import { baseApi } from '../baseApi';

export const uploadApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    uploadImage: builder.mutation<{ success: boolean; url: string; path: string; filename: string }, { formData: FormData; folder?: string; subfolder?: string }>({
      query: ({ formData, folder, subfolder }) => ({
        url: `/api/upload/image`,
        method: 'POST',
        body: formData,
        params: { folder, subfolder }
      }),
    }),
    uploadFile: builder.mutation<{ success: boolean; url: string; path: string; filename: string }, { formData: FormData; folder?: string; subfolder?: string }>({
      query: ({ formData, folder, subfolder }) => ({
        url: `/api/upload/file`,
        method: 'POST',
        body: formData,
        params: { folder, subfolder }
      }),
    }),
  }),
});

export const { useUploadImageMutation, useUploadFileMutation } = uploadApi;
